import React from 'react';
import Sun from './Sun/Sun';
import Clouds from './Clouds/Clouds';

import Css from './home.module.css';

export default function Home() {
    return <div className={Css.Container}>
        <Sun />
        <Clouds />
        <div className={Css.headingContainer}>
            <h1 className={Css.mainHeading}>I'm Shweta</h1>
            <span className={Css.info}>Full Stack (MERN) Developer.</span>
        </div>
    </div>;
}
